<template>
  <div>
    <div class="dropify-wrapper" style="width: 75px; height: 75px;padding: 0; border: 1px solid #e8e8e8; border-radius: 4px; background: white">
      <div v-if="value" class="dropify-message">
        <img width="width: 100%" style="width: 100%" :src="value" alt=""/>
      </div>
      <div v-else class="dropify-message">
        <span class="file-icon" style="font-size: 35px"></span>
      </div>
      <input
          multiple
          type="file"
          accept="image/*"
          ref="fileInput"
          @change="inputChange"
          @click="$refs.fileInput.value = null"
      />
    </div>
    <p v-if="message" class="text-danger" style="font-size: 12px">{{ message }}</p>
  </div>
</template>

<script>
import FileMixin from "@/mixins/FileMixin";

export default {
  props: {
    value: null,
    errors: Array
  },
  name: "ImagePicker",
  mixins: [FileMixin],
  computed: {
    message() {
      return this.errors && this.errors.length > 0 ? this.errors.join(", ") : null
    }
  },
  methods: {
    async inputChange(file) {
      const res = await this.upload(file)
      this.$emit('input', res.path)
    },
  }
}
</script>

<style scoped>
@import "../../assets/libs/dropify/dist/css/dropify.css";
</style>